import * as langObj from 'element-plus/es/locale/index';
import ph from './ph';
export default {
  ...langObj,
  ph
};
